import React from "react";

const NearbyAttractions = () => {
  const attractions = [
    {
      title: "Water Park",
      description:
        "Lighthouse Water Park in Mansar is located just 20 km away from Woodland Escape. It features over 40 attractions including several large pools, more than 15 water slides, and a wave pool — perfect for families and thrill seekers alike.",
      image: "/images/water-park.jpg",
    },
    {
      title: "Ramtek Temple",
      description:
        "The famous 100-year-old Ramtek Temple is situated 25 km from the Woodland Escape. Perched on a hilltop, this temple offers a peaceful spiritual experience and panoramic views of the surrounding countryside.",
      image: "/images/ramtek.avif",
    },
    {
      title: "Tiger Safari",
      description:
        "Woodland Escape is conveniently located close to multiple Tiger Safari gates in both Maharashtra and Madhya Pradesh. The nearest gate, Khursapar, is only 10 km away — offering guests a thrilling chance to witness wildlife in its natural habitat.",
      image: "/images/safari.jpg",
    },
  ];

  return (

<>
<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
               <h1>Nearby Attractions</h1>
    </div>
  </div>
</section>



    <section className="nearby-section">
      <div className="section-header">
        <img
          src="/images/logo.jpg"
          alt="Woodland Escape Logo"
          className="resort-logo"
        />
        <h2>Nearby Attractions</h2>
      </div>

      <div className="attractions-container">
        {attractions.map((place, index) => (
          <div className="attraction-card" key={index}>
            <img
              src={place.image}
              alt={place.title}
              className="attraction-img"
              loading="lazy"
            />
            <div className="attraction-content">
              <h3>{place.title}</h3>
              <p>{place.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>

</>
  );
};

export default NearbyAttractions;
